import { requestWithToken } from '../../utilities/request';

/**
 * 利用者一覧取得API
 * @param {object}param
 */
const fetchUserListByRole = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/users/list_by_role',
    params: param,
  });
};

/**
 * 利用者一覧取得API(ユーザー画面利用)
 * @param {object}param
 * @description ログインユーザーの種別に関係なくユーザーリスト情報を取得する
 */
const fetchUserList = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/users/list',
    params: param,
  });
};

/**
 * 会社・ユーザー権限一覧を取得API
 * @param {string}companyId
 * @param {object}param
 */
const fetchCompanyUserPermissions = (companyId, param) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/companies/${companyId}/company_user_permissions/list`,
    params: param,
  });
};

/**
 * サービス権限一括変更API
 * @param {object}data
 */
const updateServicePermissions = data => {
  return requestWithToken({
    method: 'PATCH',
    url: '/api/private/users/bulk_update_informations',
    data,
  });
};

/**
 * 会社・ユーザー権限取得API
 * @param {string}companyId
 */
const fetchCompanyUserPermission = companyId => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/companies/${companyId}/company_user_permission`,
  });
};

const bulkUpdatePartnerCompanyBranch = (data, useDefaultCatch) => {
  return requestWithToken(
    {
      method: 'POST',
      url: '/api/private/users/bulk_update_partner_company_branch',
      data,
    },
    useDefaultCatch
  );
};

export const UsersApi = {
  fetchUserListByRole,
  fetchUserList,
  fetchCompanyUserPermissions,
  updateServicePermissions,
  fetchCompanyUserPermission,
  bulkUpdatePartnerCompanyBranch,
};

export default UsersApi;



// WEBPACK FOOTER //
// ./src/services/users/UsersApi.js